import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import NorthStar from "./NorthStar";

export default function Preloader({ onDone }) {
  const [done, setDone] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => {
      setDone(true);
      onDone?.();
    }, 1700);
    return () => clearTimeout(t);
  }, [onDone]);

  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          className="fixed inset-0 z-[9997] flex items-center justify-center bg-ink"
          exit={{ y: "-100%" }}
          transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
        >
          <div className="flex flex-col items-center gap-6">
            <motion.div
              animate={{ rotate: 360, opacity: [0.4, 1, 0.4] }}
              transition={{ duration: 1.6, ease: "easeInOut", repeat: Infinity }}
            >
              <NorthStar className="w-7 h-7 text-warm" />
            </motion.div>
            <motion.span
              className="label"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.3 }}
            >
              NSTR Talent
            </motion.span>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
